<!--Show CaseId and/or Patient in context-->
<div *ngIf="caseId || (memberId && patientName)" class="row ml-0" style="margin-bottom:-5px;">
  <div class="col-7 pr-0">
    <label class="k-form-field w-100 pr-3" *ngIf="memberId && patientName">
      <span class="k-text-uppercase dark">
        {{patientLabel.patientLabel}}
        <input kendoTextBox [disabled]="true" [(ngModel)]="patientName" class="w-100" />
      </span>
    </label>
  </div>
  <div class="col-5">
    <label class="k-form-field w-100 pr-3" *ngIf="caseId">
      <span class="k-text-uppercase dark">
        {{'CASE-ID-NUMBER' | translate}}
        <input kendoTextBox [disabled]="true" [(ngModel)]="caseId" class="w-100" />
      </span>
    </label>
  </div>
</div>
<form [formGroup]="messageForm" class="k-form" (ngSubmit)="onSubmit($event)">
  <div class="col-sm-12">
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'TO' | translate}} *
      </span>
      <kendo-multiselect type="text" [data]="toUsersFiltered" valueField="id" textField="name" formControlName="to"
        role="combobox" attr.aria-label="{{'TO' | translate}}" [filterable]="true"
        (filterChange)="filterToUsers($event)" (close)="searchTerm=''" [itemDisabled]="itemDisabled"
        [valueNormalizer]="toAddressNormalizer" [allowCustom]="kno2Enabled" [ngClass]="{'to-address': kno2Enabled}"
        aria-expanded="false" aria-controls=".k-list-ul">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
          </span>
        </ng-template>
      </kendo-multiselect>
      <div class="k-tooltip k-tooltip-validation" *ngIf="to.hasError('required') && to.touched" role="alert">
        {{'MESSAGE-TO-ADDRESS-REQUIRED' | translate}}
      </div>
      <button *ngIf="kno2Enabled" kendoButton [primary]="false" title="{{ 'FIND-PROVIDER' | translate }}"
        class="mr-2 search-icon-button" (click)="searchDirectory()" type="button"
        style="position: absolute;right: 7px;top: 25px;">
        <i class="far fa-search"></i>
      </button>
    </label>
  </div>
  <div class="col-sm-12">
    <label class="k-form-field" *ngIf="isAddressesContainsDirect(to.value)">
      <span class="k-text-uppercase dark">
        {{'FROM-DIRECT-ADDRESS' | translate}} *
      </span>
      <kendo-combobox id="fromDirectAddress" formControlName="fromDirectAddress" class="w-100" [valuePrimitive]="true"
        [data]="kno2DocumentSources" [textField]="'fullAddress'" [valueField]="'fullAddress'">
      </kendo-combobox>
    </label>
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'SUBJECT' | translate}} *
      </span>
      <input id="subject" kendoTextBox formControlName="subject" />
      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="subject.hasError('required') && subject.touched">
        {{'MESSAGE-SUBJECT-REQUIRED' | translate}}
      </div>
    </label>
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'BODY' | translate}} *
      </span>
      <textarea id="body" kendoTextArea rows="3" formControlName="body" class="w-100"></textarea>
      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="body.hasError('required') && body.touched">
        {{'MESSAGE-BODY-REQUIRED' | translate}}
      </div>
    </label>
    <div class="row k-form">
      <label class="k-form-field file-list w-100">
        <div class="col-sm-12">
          <div class="row mt-1" *ngFor="let f of selectedFiles">
            <div class="col-sm-11">
              <i class="fas fa-file fa-lg" class="fa {{getFileTypeClass(f.type)}}" title="{{f.name}}"></i>
              {{f.name}}
            </div>
            <div class="col-sm-1 pointer" style="max-width:40px;position:absolute;right:0px">
              <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteAttachment(f.name)"
                role="button" attr.aria-label="{{ 'DELETE' | translate }}" tabindex="0"
                (keydown.enter)="deleteAttachment(f.name)" (keydown.space)="deleteAttachment(f.name)">
              </i>
            </div>
          </div>
        </div>
      </label>
    </div>
    <div class="row k-form" *ngIf="attachmentsEnabled">
      <label class="k-form-field">
        <kendo-upload class="d-none" [autoUpload]="false" [multiple]="true" (select)="onFileChanged($event)">
        </kendo-upload>
        <button kendoButton [primary]="true" type="button" (click)="selectAttachment()" [disabled]="savingMessage">
          {{'ADD-DOCUMENT' | translate}}<i class="far fa-plus"></i>
        </button>
      </label>
    </div>
  </div>
</form>
<div>* {{'REQUIRED-FIELDS' | translate}}</div>

<!--Search directory-->
<app-directory-search #directorySearch [allowSelection]="true" [showOrganizationsTab]="true" [disableEscape]="true"
  [allowFacilitySearch]="true" [memberId]="memberId" (selectProvider)="onSelectProviders($event)">
</app-directory-search>